import { AnalyticsCardRoot } from "./AnalyticsCardRoot/AnalyticsCardRoot";
import { AnalyticsCardHeader } from "./AnalyticsCardHeader/AnalyticsCardHeader";
import { AnalyticsCardTitle } from "./AnalyticsCardTitle/AnalyticsCardTitle";

export const Root = AnalyticsCardRoot;
export const Header = AnalyticsCardHeader;
export const Title = AnalyticsCardTitle;
